settings_module = settings_module or {}
settings_module.account = ->

    # dynamicka zmena v basic formulari
    # policko s heslem se objevuje jen tehdy, pokud doslo ke zmene v emailu
    $form = $('form')
    $email_input = $form.find('#id_email')
    old_email = $email_input.val()
    $password_input = $form.find("#id_password")
    $row = $password_input.closest('.form-group')
    if not $row.hasClass('has-error')
        $row.hide()
        showed = false

        $email_input.on 'change, keyup', () ->
            if $(@).val() == old_email
                if showed
                    $password_input.closest('.form-group').fadeOut()
                    showed = false
                return
            showed = true
            $password_input.closest('.form-group').fadeIn()
